/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_MalayInputs */



/**
* | output |
* | --- |
* | "Malay" |
*
* @param {Speechmatics_Target_Language_MalayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_malay = /** @type {((inputs?: Speechmatics_Target_Language_MalayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_MalayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Malais")
	if (locale === "de") return /** @type {LocalizedString} */ ("malaiisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("malese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("малайский")
	if (locale === "es") return /** @type {LocalizedString} */ ("malayo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("马来语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マレー語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मलायी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("malaio")
	return /** @type {LocalizedString} */ ("Malay")
});